export type RouteAnimation = 'fade' | 'slide-right' | 'slide-left';

export const RouteAnimation = {
  Fade: 'fade' as RouteAnimation,
  SlideRight: 'slide-right' as RouteAnimation,
  SlideLeft: 'slide-left' as RouteAnimation
};
